import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Input, Popover, Button, Modal } from '@bedrock/components'
import {useClickAway, useMemoizedFn} from 'ahooks'
import cx from 'classnames'
import './index.less'
import TextAreaShow from '../TextAreaShow/index'


//自定义受控组件
export type TextAreaPopconfirmProps = {
    view?: boolean
    value?: string
    onChange?: (value: string) => void
    showLine?: number
    linkDetector?: boolean;
    wrapperClassName?: string
    wrapperStyle?: React.CSSProperties
    renderChildren?: (value: string) => React.ReactElement
    textAreaProps?: React.ComponentProps<typeof Input.TextArea>
    defaultChildrenProps?: React.ComponentProps<typeof Input>
    /** 查看态时hover是否显示tooltip展示所有内容 */
    showTooltip?: boolean
    emptyText?: string
} & React.ComponentProps<typeof Popover>

export default function TextAreaPopover({
    value,
    onChange,
    renderChildren,
    showLine = 2,
    linkDetector,
    view = false,
    wrapperClassName,
    wrapperStyle,
    title,
    textAreaProps,
    defaultChildrenProps,
    showTooltip = true,
    emptyText = '--',
    ...otherProps
}: TextAreaPopconfirmProps) {
    const [visible, setVisible] = useState(false)
    const [content, setContent] = useState(value)
    useEffect(() => {
        setContent(value)
    }, [value])
    const inputRef = useRef(null)
    const contentRef = useRef(null)
    const childrenRef = useRef(null)
    useClickAway(() => {
        setVisible(false)
    }, contentRef)
    const children = renderChildren ? renderChildren(value) : <Input value={value} {...({...textAreaProps, ...defaultChildrenProps} as unknown as React.ComponentProps<typeof Input>)} />

    const onChangeFn = useMemoizedFn(() => {
        onChange?.(content)
    })

    useEffect(() => {
        if (visible) {
            setContent(value)
            setTimeout(() => {
                inputRef.current?.focus()
            }, 100)
        }
        return () => {
            visible && onChangeFn?.()
        }
    }, [visible])

    if (view) {
        return <div className={cx('sform-textarea-propover', wrapperClassName)} style={wrapperStyle}>
            {!value ? emptyText : <TextAreaShow value={value} showLine={showLine} showTooltip={showTooltip} showHoverTitle={showTooltip} linkDetector={linkDetector} />}
        </div>
    }


    return <div className={cx('sform-textarea-propover', wrapperClassName)} style={wrapperStyle}>
        <Popover
            visible={visible}
            showArrow={false}
            destroyTooltipOnHide
            placement="bottomLeft"
            {...otherProps}
            title={null}
            content={
                <div className="sform-textarea-propover-content" ref={contentRef}>
                    {title && <div className="sform-textarea-propover-content-title">{title}</div>}
                    <Input.TextArea
                        ref={inputRef}
                        autoSize={true}
                        block={true}
                        rows={4}
                        maxLength={500}
                        showCount={true}
                        focusCaret="end"
                        maxHeight={280}
                        placeholder={defaultChildrenProps?.placeholder}
                        {...textAreaProps}
                        value={content}
                        onChange={(e) => {
                            setContent(e.target.value)
                        }}
                    />
                    <div className="sform-textarea-propover-content-footer">
                        <Button type="default" onClick={() => {
                            setContent('')
                        }}>重置</Button>
                        {/* <Button type="primary" onClick={() => {
                            onChange?.(content)
                            setVisible(false)
                        }}>确定</Button> */}
                    </div>
                </div>
            }
        >
           {
            React.cloneElement(children as React.ReactElement, {
                ref: childrenRef,
                onClick: (e) => {
                    e.stopPropagation()
                    setVisible(true)
                    visible && inputRef.current?.focus?.()
                }
            })
           }
        </Popover>
    </div>
}
